import React from 'react';

interface QuestionTracking {
  question: string;
  openedInChapter: string;
  closedInChapter: string | null;
}

interface QuestionsTableProps {
  questions: QuestionTracking[];
  isSidebar: boolean;
  t: (key: string) => string;
}

export const QuestionsTable: React.FC<QuestionsTableProps> = ({
  questions,
  isSidebar,
  t,
}) => {
  if (questions.length === 0) {
    return null;
  }

  return (
    <div style={{ marginTop: '2rem' }}>
      <h2
        style={{
          fontSize: '1.25rem',
          fontWeight: '600',
          margin: '0 0 1rem 0',
          color: 'var(--foreground)',
        }}
      >
        {t('questions')}
      </h2>
      <div
        style={{
          backgroundColor: 'var(--card)',
          border: '1px solid var(--border)',
          borderRadius: '8px',
          overflow: 'hidden',
        }}
      >
        <div style={{ overflow: 'auto', maxWidth: '100%' }}>
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              tableLayout: 'auto',
            }}
          >
            <thead>
              <tr style={{ backgroundColor: 'var(--muted)', borderBottom: '1px solid var(--border)' }}>
                <th
                  style={{
                    padding: '1rem',
                    textAlign: 'left',
                    fontWeight: '600',
                    fontSize: '0.875rem',
                    color: 'var(--foreground)',
                    borderBottom: '1px solid var(--border)',
                  }}
                >
                  {t('question')}
                </th>
                <th
                  style={{
                    padding: '1rem',
                    textAlign: 'left',
                    fontWeight: '600',
                    fontSize: '0.875rem',
                    color: 'var(--foreground)',
                    borderBottom: '1px solid var(--border)',
                  }}
                >
                  {t('opened_in_chapter')}
                </th>
                <th
                  style={{
                    padding: '1rem',
                    textAlign: 'left',
                    fontWeight: '600',
                    fontSize: '0.875rem',
                    color: 'var(--foreground)',
                    borderBottom: '1px solid var(--border)',
                  }}
                >
                  {t('closed_in_chapter')}
                </th>
                <th
                  style={{
                    padding: '1rem',
                    textAlign: 'center',
                    fontWeight: '600',
                    fontSize: '0.875rem',
                    color: 'var(--foreground)',
                    borderBottom: '1px solid var(--border)',
                  }}
                >
                  {t('status')}
                </th>
              </tr>
            </thead>
            <tbody>
              {questions.map((q, index) => (
                <tr
                  key={index}
                  style={{
                    borderBottom: index < questions.length - 1 ? '1px solid var(--border)' : 'none',
                    transition: 'background-color 0.2s',
                  }}
                  onMouseEnter={(e) => {
                    (e.currentTarget as HTMLTableRowElement).style.backgroundColor = 'var(--muted)';
                  }}
                  onMouseLeave={(e) => {
                    (e.currentTarget as HTMLTableRowElement).style.backgroundColor = 'transparent';
                  }}
                >
                  <td style={{ padding: '1rem', fontSize: '0.875rem', color: 'var(--foreground)' }}>
                    {q.question}
                  </td>
                  <td style={{ padding: '1rem', fontSize: '0.875rem', color: 'var(--muted-foreground)' }}>
                    {q.openedInChapter}
                  </td>
                  <td style={{ padding: '1rem', fontSize: '0.875rem', color: 'var(--muted-foreground)' }}>
                    {q.closedInChapter || '-'}
                  </td>
                  <td style={{ padding: '1rem', textAlign: 'center', fontSize: '0.875rem' }}>
                    {q.closedInChapter ? (
                      <span
                        style={{
                          display: 'inline-block',
                          padding: '0.25rem 0.75rem',
                          borderRadius: '9999px',
                          backgroundColor: '#d1fae5',
                          color: '#065f46',
                          fontWeight: '500',
                        }}
                      >
                        {t('closed')}
                      </span>
                    ) : (
                      <span
                        style={{
                          display: 'inline-block',
                          padding: '0.25rem 0.75rem',
                          borderRadius: '9999px',
                          backgroundColor: '#fef3c7',
                          color: '#92400e',
                          fontWeight: '500',
                        }}
                      >
                        {t('open')}
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

